export enum OrderStatusTypes {
  Open = 1,
  Canceled = 2,
  Completed = 4,
  Voided = 8,
  OpenTab = 16,
  PosOutOfSync = 32,
  CancelPending = 64,
  VoidPending = 128,
}
